import {createAction, props} from "@ngrx/store";
import {CompanyInterface} from "../interfaces/company.interface";
import {RestaurantInterface} from "../interfaces/restaurant.interface";
import {
    CurrentRestaurantSubscriptionInterface
} from "../../app/global/billings/interfaces/current-restaurant-subscription.interface";

export const GetCompany = createAction('[Store] GetCompany');
export const GetRestaurants = createAction('[Store] GetRestaurants');
export const RefreshCurrentRestaurant = createAction('[Store] RefreshCurrentRestaurant');
export const UpdateCompany = createAction('[Store] UpdateCompany', props<{data: Partial<CompanyInterface>}>());
export const SetRestaurants = createAction('[Store] SetRestaurants', props<{restaurants: RestaurantInterface[]}>());
export const SetCurrentRestaurant = createAction('[Store] SetCurrentRestaurant', props<{restaurant: RestaurantInterface}>());
export const GetSubscription = createAction('[Store] GetSubscription');
export const SetSubscription = createAction('[Store] SetSubscription', props<{subscription: CurrentRestaurantSubscriptionInterface}>());
export const ClearStore = createAction('[Store] ClearStore');
